/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { Popover } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FiInfo } from "react-icons/fi";

import { Container, HelperTooltip, Message, Title, useStyles } from "./styles";

const AppGalleryPermissionTooltip: React.FC = () => {
  const { t: translate } = useTranslation();

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const isOpened = Boolean(anchorEl);

  const onOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl((prev) => (!prev ? event.currentTarget : prev));
  };
  const onClosePopover = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <HelperTooltip onMouseEnter={onOpenPopover}>
        <FiInfo />
      </HelperTooltip>

      <Popover
        id={isOpened ? "AppGalleryPermissionTooltip" : undefined}
        open={isOpened}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          className: classes.paper,
        }}
      >
        <Container>
          <Title>{translate("allowItemPhotosToBeUploadedFromTheDevicesImageGallery")}</Title>
          <Message>
            {translate("thisSettingsEnablesMobileAppUsersToUploadImagesFromTheirDevicesGallery")}.
          </Message>
          <Message>
            {translate("note")}:{" "}
            {translate(
              "thisMayCauseADataSecurityRiskAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices"

            )}
            .
          </Message>
        </Container>
      </Popover>
    </>
  );
};

export default AppGalleryPermissionTooltip;
